/// <amd-module name="Wit/UI/ComponentProviders/index" />
export * from "./WorkItemStateProvider";
export { IWorkItemStateProviderProps, WorkItemStateInfo } from "./WorkItemStateProvider.Props";

export * from "./WorkItemTypeIconProvider";
export { IWorkItemTypeIconProviderProps, WorkItemTypeInfo } from "./WorkItemTypeIconProvider.Props";
